import { Link } from "react-router-dom";

export const SectionHeader = ({ index, label, title }) => {
  const slug = label.toLowerCase().replaceAll(" ", "-");
  return <div className="section-heading"><p className="section-index" data-testid={`${slug}-section-index`}>{index}</p><div><p className="eyebrow" data-testid={`${slug}-section-label`}>{label}</p>{title && <h2 data-testid={`${slug}-section-title`}>{title}</h2>}</div></div>;
};

export const ResearchCard = ({ number, title, description, to, testId }) => (
  <Link className="research-card" to={to} data-testid={testId}>
    <div className="card-meta"><span>{number}</span><span className="card-arrow" aria-hidden="true">↗</span></div>
    <div><h3>{title}</h3><p>{description}</p></div>
  </Link>
);